import { Link, type LinkProps } from 'react-router'
import { cn } from '@/helpers/utils'
import { type ButtonProps, buttonVariants } from './button-legacy'

export type ButtonLinkProps = LinkProps &
	ButtonProps & {
		disabled?: boolean
		ref?: React.Ref<HTMLAnchorElement>
	}

/**
 * @deprecated Legacy link button. Use `ButtonLink` from
 * `@/components/ui/button-link` (ported from airbnb-elevate-fe) for new code.
 */
function ButtonLinkLegacy({
	shape = 'rectangle',
	size = 'md',
	className,
	children,
	disabled,
	ref,
	variant,
	...props
}: ButtonLinkProps) {
	return (
		<Link
			aria-disabled={disabled}
			className={buttonVariants({
				variant,
				size,
				shape,
				className: cn('group', className, disabled && 'disabled')
			})}
			data-slot='button'
			onClick={(event) => {
				if (disabled) {
					event.preventDefault()
					event.stopPropagation()
				} else {
					props.onClick?.(event)
				}
			}}
			ref={ref}
			tabIndex={disabled ? -1 : undefined}
			{...props}
		>
			{children}
		</Link>
	)
}

export { ButtonLinkLegacy }
